import React, { useCallback, useState } from "react";
import { Typography, FormLabel, FormHelperText } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Dropzone from "./Dropzone";
import ImageList from "./ImageList";

function DragDropWithImage({
  onChange,
  initialImageUrl = "",
  label = "",
  caption = "",
  onError,
  errorMessage,
  maxCount = 10,
}) {
  const initialData = initialImageUrl.includes(",")
    ? initialImageUrl.split(",").map((url, index) => ({ id: index, src: url }))
    : initialImageUrl
      ? [{ src: initialImageUrl }]
      : [];
  const [images, setImages] = useState(initialData);
  const onDrop = useCallback(
    (acceptedFiles) => {
      const formattedFileImages = images.map(
        ({ file, src }) => file || { src },
      );
      const combineData = [...formattedFileImages, ...acceptedFiles];
      if (combineData.length > maxCount) {
        return onError(`Maximum ${maxCount} Images are allowed`);
      }
      onChange([...formattedFileImages, ...acceptedFiles]);
      onError("");
      acceptedFiles.map((file) => {
        const reader = new FileReader();
        reader.onload = function (e) {
          setImages((prevState) => [
            ...prevState,
            {
              id: prevState && prevState.length + 1,
              src: e.target.result,
              file,
            },
          ]);
        };
        reader.readAsDataURL(file);
        return file;
      });
    },
    [JSON.stringify(images)],
  );
  const removeImage = (image, deleteIndex) => {
    const newImages = images.filter((_, index) => deleteIndex !== index);
    const formattedFileImages = newImages.map(
      ({ file, src }) => file || { src },
    );
    onChange([...formattedFileImages]);
    setImages(newImages);
  };
  const moveImage = (newData) => {
    const formattedFileImages = newData.map(({ file, src }) => file || { src });
    onChange([...formattedFileImages]);
    setImages(newData);
  };

  return (
    <>
      <Grid container direction="row" spacing={2} style={{ padding: "10px 0" }}>
        <Grid size={{ xs: 12 }}>
          <FormLabel>{label}</FormLabel>
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Typography variant="caption">{caption}</Typography>
        </Grid>
      </Grid>
      <Dropzone onDrop={onDrop} accept={"image/*"} />
      {images && images.length ? (
        <Grid size={{ xs: 12 }} style={{ marginTop: 8 }}>
          <FormLabel>Drag the Images to change positions</FormLabel>
        </Grid>
      ) : null}
      {errorMessage ? (
        <FormHelperText error>{errorMessage}</FormHelperText>
      ) : null}
      <ImageList
        images={images}
        moveImage={moveImage}
        removeImage={removeImage}
      />
    </>
  );
}

export default DragDropWithImage;
